export default "__VITE_ASSET__CaOftEjg__"